
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { adminMenuSections } from "../sidebar/MenuItems";

export const useSidebarData = () => {
  const [unpaidCount, setUnpaidCount] = useState(0);
  const [unapprovedCount, setUnapprovedCount] = useState(0);

  const checkUnpaidItems = async () => {
    try {
      const { count } = await supabase
        .from('bills')
        .select('id', { count: 'exact', head: true })
        .eq('status', 'unpaid');

      setUnpaidCount(count || 0);
    } catch (error) {
      console.error('Error checking unpaid items:', error);
    }
  };

  const checkUnapprovedUsers = async () => {
    try {
      const { count } = await supabase
        .from('school_users')
        .select('id', { count: 'exact', head: true })
        .eq('approved', false);

      setUnapprovedCount(count || 0);
    } catch (error) {
      console.error('Error checking unapproved users:', error);
    }
  };

  useEffect(() => {
    checkUnpaidItems();
    checkUnapprovedUsers();
    // Set up an interval to check every minute
    const interval = setInterval(() => {
      checkUnpaidItems();
      checkUnapprovedUsers();
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  // Get items directly from the categorized sections
  const { adminDashboard, clientManagement, financial, api } = adminMenuSections;

  return {
    adminItems: adminDashboard,
    clientItems: clientManagement,
    apiItems: api,
    financialItems: financial,
    unpaidCount,
    unapprovedCount
  };
};
